export const ORGANISATION_PROFILE = '/api/user/v1/organisation-profile';
export const UPDATE_ORGANISATION_PROFILE = '/api/user/v1/organisation-profile-update';
